(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["partner-modal"] && !Shopify.designMode) return;
  try {
    const indiaStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry"
];

document.addEventListener("DOMContentLoaded", function () {
  const stateSelect = document.getElementById("PartnerStateSelect");

  if (stateSelect) {
    indiaStates.forEach(function(state) {
      const option = document.createElement("option");
      option.value = state;
      option.textContent = state;
      stateSelect.appendChild(option);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const openBtn = document.getElementById("PartnerOpenBtn");
  const modal = document.getElementById("PartnerModal");
  const closeBtn = document.querySelector(".partner-modal__close");
  const overlay = document.querySelector(".partner-modal__overlay");

  if(openBtn){
    openBtn.addEventListener("click", function(e){
      e.preventDefault();
      modal.classList.add("active");
    });
  }

  function closeModal(){
    modal.classList.remove("active");
  }

  closeBtn.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal);

});
  } catch(e) { console.error(e); }
})();

})();
